<template>
  <div
    class="bg-white dark:bg-gray-800 rounded-xl border-2 p-6 transition-all"
    :class="
      isNowPlaying
        ? 'border-green-400 dark:border-green-500 bg-green-50/40 dark:bg-green-900/20 ring-2 ring-green-300 dark:ring-green-500'
        : 'border-gray-200 dark:border-gray-700'
    "
  >
    <div class="flex items-center gap-4">
      <div
        class="w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center font-bold text-xl text-white shrink-0"
        :class="isNowPlaying ? 'bg-green-500 dark:bg-green-600 animate-pulse' : 'cs-queue-badge text-white'"
      >
        <i v-if="isNowPlaying" class="pi pi-microphone text-2xl"></i>
        <span v-else>{{ queueNumber }}</span>
      </div>

      <div class="flex-1 min-w-0">
        <h3 class="text-xl font-semibold text-gray-900 dark:text-white truncate">
          {{ entry.song?.title || "Unknown" }}
        </h3>
        <p v-if="entry.song?.author" class="text-gray-600 dark:text-gray-400 text-sm truncate">
          {{ entry.song.author }}
        </p>
      </div>

      <div class="text-right shrink-0">
        <span class="inline-flex items-center gap-1.5 font-heading text-base font-semibold tracking-wide text-gray-800 dark:text-gray-200">
          <i class="pi pi-user text-sm text-gray-500 dark:text-gray-400"></i>
          {{ entry.performerName }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KaraokeQueueRow",
  props: {
    entry: { type: Object, required: true },
    queueNumber: { type: Number, default: 0 },
    isNowPlaying: { type: Boolean, default: false }
  }
};
</script>
